// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { addDays as fn } from "../addDays.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addDaysWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default addDaysWithOptions;
